import InterpolatorFactory from './Factory';
import InterpolatorSelector from './InterpolatorSelector';

module.exports = {
  InterpolatorFactory, InterpolatorSelector
}
